import { hospitalLoginActions } from '../../../../actions/user/hospital/Account/login';

const initialState = {
  user: null,
  loading: false,
  error: null,
  successMessage: null,
  isVerified: false,
  isAuthenticated: false,
  isModalOpen: false
};

const hospitalLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case hospitalLoginActions.LOGIN_HOSPITAL.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null
      };
    case hospitalLoginActions.LOGIN_HOSPITAL.SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
        successMessage: action.payload.message,
        isAuthenticated: true,
        isVerified: action.payload.is_email_verified,
        isModalOpen: !action.payload.is_email_verified
      };
    case hospitalLoginActions.LOGIN_HOSPITAL.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error?.error,
        isVerified: false,
        isModalOpen: action.error?.error === 'Please verify your email first'
      };
    case hospitalLoginActions.LOGIN_HOSPITAL.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default hospitalLoginReducer;
